import axios from "axios";

export const getVacancies = async (type) => {
  const response = await axios.get(`/api/vacancies?filters[type][$eq]=${type}`);
  return response.data;
};
